
export default class PlayHistory {

  constructor(
    private _playedCount: number
  ) { }

  get playedCount(): number {
    return this._playedCount
  }
}
